import { FORMATIONS } from "@/data/constants";

// sum expected goal contribution of an assignment {slot: playerId} using squad values
export function computeEGD(assignment, squad) {
  const byId = {};
  squad.forEach((p) => (byId[p.id] = p));
  let sum = 0;
  Object.entries(assignment).forEach(([slot, pid]) => {
    const p = byId[pid];
    const v = p?.values?.[slot];
    if (v !== undefined) sum += v;
  });
  return Math.round(sum * 10000) / 10000;
}

// LGD given optimal egd (clamped >= 0 as safety net)
export function computeLGD(optimalEGD, egd) {
  return Math.max(0, Math.round((optimalEGD - egd) * 10000) / 10000);
}

// agreement count between two assignments (same player in same slot)
export function agreement(a, b) {
  let n = 0;
  Object.keys(a).forEach((slot) => {
    if (b[slot] && b[slot] === a[slot]) n += 1;
  });
  // also count same player appearing in a differing slot as partial? keep strict slot match
  return n;
}

// how many of the same 11 players (regardless of slot)
export function samePlayers(a, b) {
  const sa = new Set(Object.values(a));
  const sb = new Set(Object.values(b));
  let n = 0;
  sa.forEach((p) => { if (sb.has(p)) n += 1; });
  return n;
}

// per-slot divergence rows across union of slots
export function divergenceRows(you, coach, ai) {
  const slots = new Set([...Object.keys(you), ...Object.keys(coach), ...Object.keys(ai)]);
  const rows = [];
  slots.forEach((slot) => {
    const y = you[slot], c = coach[slot], a = ai[slot];
    const diverges = !(y === c && c === a);
    if (diverges) rows.push({ slot, you: y, coach: c, ai: a });
  });
  return rows;
}

// cost of a divergence: what you lost at that slot vs the optimal(ai) slot value
export function slotCost(slot, youPid, squad, optimalEGD, aiAssignment) {
  const byId = {};
  squad.forEach((p) => (byId[p.id] = p));
  const yv = byId[youPid]?.values?.[slot];
  const av = byId[aiAssignment[slot]]?.values?.[slot];
  if (yv === undefined || av === undefined) return null;
  return Math.max(0, Math.round((av - yv) * 10000) / 10000);
}

export function emptyAssignment() {
  return {};
}

export function isValidXI(assignment, formation) {
  const slots = FORMATIONS[formation];
  const filled = slots.every((s) => assignment[s]);
  const gk = !!assignment["GK"];
  const count = Object.keys(assignment).filter((s) => assignment[s]).length;
  return filled && gk && count === 11;
}

// legal move check: is player eligible for slot
export function playerEligible(player, slot) {
  return player?.values?.[slot] !== undefined;
}
